import { createFeatureSelector, createSelector } from '@ngrx/store';
import { registrationFeatureKey, State } from './registration.reducer';

export const selectRegistrationFeature = createFeatureSelector<State>(registrationFeatureKey);

export const selectRegistration = createSelector(selectRegistrationFeature, (state) => state.registrationResult);

export const selectRegistrationIsRegisteringInProgress = createSelector(
  selectRegistrationFeature,
  (state) => state.isRegisteringInProgress
);

export const selectRegistrationIsLoading = createSelector(selectRegistrationFeature, (state) => state.isLoading);

export const selectRegistrationHasError = createSelector(selectRegistrationFeature, (state) => state.hasError);

export const selectRegistrationErrorType = createSelector(selectRegistrationFeature, (state) => {
  if (!state.hasError) {
    return null;
  }
  // TODO 19-Aug-2026/tabe: refactor to use error type from registrationResult instead of checking isServerError and isTimedOut
  if (!state.registrationResult || state.registrationResult.isServerError || state.registrationResult.isTimedOut) {
    return 'general';
  }

  return 'expired';
});

export const selectRegistrationQrCodeDataUri = createSelector(
  selectRegistration,
  (registration) => registration?.qrCode?.dataUri || null
);
